// src/utils/userUtils.ts
export const setUserLocal = (user: any) => {
  localStorage.setItem("user", JSON.stringify(user));
};

export const getUserLocal = () => {
  const s = localStorage.getItem("user");
  return s ? JSON.parse(s) : null;
};

export const removeUserLocal = () => {
  localStorage.removeItem("user");
};